import React from "react";

export const Page3Tamil = () => {
  return (
    <div className="page-tamil-container">
      <p style={{ fontWeight: "bold" }}>
        "ஆதியண்ணன் கோயிலுக்கு கீழ்திசையில் நேர்எதிரே அமைந்து அருள் பாலித்துக்
        கொண்டிருக்கும் "அய்யனாரின் பிறப்பு சிறப்பு வரலாறு"
      </p>
      <p>
        கலியுகத்தில் தம்மை வணங்கும் பக்தர்களின் விருப்பங்களை விரைந்து பூர்த்தி
        செய்தருளும் வள்ளலாய் திகழ்பவர் பகவான் ஸ்ரீ மஹா சாஸ்தா தமிழக மக்கள் இவரை
        மரியாதையுடன் அய்யனார் என அழைத்து வணங்குகின்றனர்.
      </p>
      <p>
        முன்னொரு சமயம் தாருகாவனத்தில் வாழ்ந்த தவசீலர்கள் மேன்மை தரும்
        வேதநெறியினை புறக்கணித்து வாழ்ந்த போது அவர்களை திருத்தி நன்னெறியில் வாழ
        வைக்க விரும்பிய சிவபெருமானும் மஹாவிஷ்ணுவும் முறையே பிட்சாடணராகவும்,
        மோகினியாகவும், வடிவெடுத்து திவ்ய லீலைகளை புரிந்து அந்த தவசீலர்களை
        நல்வழிப்படுத்தினர். அச்சமயத்தில் சிவபெருமான் எடுத்த பிட்சாடன உருவின் அதி
        அற்புத அழகை கண்டு மஹா விஷ்ணுவாகிய மோகினி காதல் கொள்ளவே அதன் பயனாய்
        அவதரித்தவர் பகவான் ஸ்ரீ மஹா சாஸ்தா.
      </p>
      <p>
        பகவான் அவதரித்தவுடன் அவரது தந்தையான சிவபெருமான் அவரை எல்லா உலகங்களையும்
        ஆளும் "புவனேஸ்வரராக" பட்டாபிஷேகம் செய்து வைத்தார். அன்று முதல் பகவான்
        மஹாசாஸ்தாவும் எல்லா உலகங்களுக்கும் ஈஸ்வரராய் இருந்து தமது பரிவாரங்களான
        ஸ்ரீ மதுரை வீரனார், ஸ்ரீ மஹாகாளர், ஸ்ரீ பெரியாச்சி, ஸ்ரீ தூண்டிக்காரர்
        போன்றவர்கள் சகிதமாக அகில உலகங்களையும் பாதுகாத்து வருகிறார்
      </p>
      <p>
        அவர் ஹரியாகிய மஹாவிஷ்ணுவிற்கும் ஹரனாகிய சிவபெருமானுக்கும் குழந்தையாய்
        அவதரித்ததால் "ஹரிஹரபுத்திரர்" என்றும் எல்லா உலகங்களையும் அரசாள்வதால்
        மஹாசாஸ்தா என்றும் பிரும்மாதி தேவர்கள் யாவரையும் விட மேம்பட்டு
        விளங்குவதால் “தேனோத்தமர்” என்றும் பல்வேறு சிறப்பு பெயர்களை பெற்று எல்லா
        ஆராதிக்கப்பட்டு வருகிறார்.
      </p>
      <p>
        அவர் நேபாள தேச இளவரசியான ஸ்ரீ புஷ்களாம்பிகா தேவியையும் வஞ்சிதேச
        இளவரசியான ஸ்ரீ பூர்ணாம்பிகா தேவியையும் திருமணம் செய்து கொண்டார்.
        பிரிதொரு சமயம் காசி மன்னர் திருமகளான ஸ்ரீ பிரபாதேவியை திருமணம் செய்து
        கொண்டு பெரும் வீரதீரம் பொருந்திய சத்தியகர் என்ற திருமகளை பெற்றதாக
        புராணங்களும், ஆகமங்களும் கூறுகின்றன. தம்மை வணங்கி வழிபடும் பக்தர்கள் எதை
        விரும்பினாலும் அதனை கட்டியிழுத்து வந்து தமது பக்தர்களின் காலடியில்
        வீழ்த்தும் அனுக்கிரஹமூர்த்தி என மந்திர சாஸ்திர நூல்கள் சாஸ்தாவை
        போற்றுகின்றன. மேலும் கந்த புராணத்தில் பகவான் அவதரித்தவுடன் சிவபெருமான்
        அவரை மும்மூர்த்தி ஸ்வரூபர் என கூறி போற்றுகிறார். ஆதலால் நாம் பகவான் ஸ்ரீ
        மஹா சாஸ்தாவை வணங்கினால் பிரும்மா, விஷ்ணு, சிவன் என்ற முப்பெரும்
        தெய்வங்களையும் வணங்கிய பெரும் புண்ணிய பலனை அடையலாம்.
      </p>
      <p style={{ margin: 0  }}>
        நாம் ஐயனாரை வணங்கினால் சனீஸ்வரர் உட்பட்ட நவக்கிரகங்களின் பீடைகளிலிருந்து
        விடுபடலாம். மேலும், சனிக்கிழமை, புதன்கிழமை, பகவானின் ஜென்ம நட்சத்திர
        தினமான உத்திர நட்சத்திர தினங்கள் ஆகியவற்றில் விரதம் இருந்து ஐயனாரை
        ஆராதித்தால் நமது விருப்பங்கள் யாவும் விரைவில் கை கூடும்.
      </p>
        
    </div>
  );
};
